export default "__VITE_ASSET__OPDJdLw8__"